export default __webpack_public_path__ + "static/media/Food_Tour.a861cd15.jpg";